import { useNavigate } from "react-router-dom";
import { Prohibit, ArrowLeft } from "@phosphor-icons/react";

export default function NotFound() {
  const navigate = useNavigate();
  return (
    <div
      data-testid="not-found-page"
      className="min-h-screen flex flex-col items-center justify-center bg-background text-foreground px-6"
    >
      <Prohibit size={48} weight="duotone" className="text-muted-foreground" />
      <p className="mt-6 font-mono text-xs uppercase tracking-[0.3em] text-muted-foreground">Error 404</p>
      <h1 className="mt-2 font-display font-extrabold tracking-tighter text-5xl sm:text-6xl text-center">
        Not found
      </h1>
      <p className="mt-4 text-sm text-muted-foreground text-center max-w-sm leading-relaxed">
        This route is unavailable. Modules that are disabled — such as Club Management — resolve here safely.
      </p>
      <button
        data-testid="notfound-home-button"
        onClick={() => navigate("/")}
        className="mt-8 flex items-center gap-2 border border-black/10 dark:border-white/10 px-6 py-3 text-xs uppercase tracking-[0.15em] hover:bg-primary hover:text-primary-foreground hover:border-primary transition-colors active:scale-95"
      >
        <ArrowLeft size={16} weight="bold" /> Return to Platform Core
      </button>
    </div>
  );
}
